import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-619179dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "idv"
}
const _hoisted_2 = {
  key: 1,
  class: "idv"
}
const _hoisted_3 = {
  key: 2,
  class: "idv"
}
const _hoisted_4 = { class: "idv__info" }
const _hoisted_5 = { class: "idv__options" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "idv__settings"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorNoAccess = _resolveComponent("ErrorNoAccess")!
  const _component_ErrorInstanceLoad = _resolveComponent("ErrorInstanceLoad")!
  const _component_InstanceDetailInfo = _resolveComponent("InstanceDetailInfo")!
  const _component_InstanceDetailOptionsR = _resolveComponent("InstanceDetailOptionsR")!
  const _component_InstanceDetailSettings = _resolveComponent("InstanceDetailSettings")!
  const _component_ModalQrCode = _resolveComponent("ModalQrCode")!
  const _component_ModalEventLog = _resolveComponent("ModalEventLog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isNoAccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ErrorNoAccess)
        ]))
      : (_ctx.isLoadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ErrorInstanceLoad)
          ]))
        : (_ctx.hasInstanceAccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_InstanceDetailInfo, { "paid-options": _ctx.safePaidOptions }, null, 8, ["paid-options"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                (
					_ctx.safePaidOptions.length < _ctx.safeOptionList.length &&
					_ctx.safeInstance.status !== _ctx.STATUS.DELETE
				)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_InstanceDetailOptionsR, { "paid-options": _ctx.safePaidOptions }, null, 8, ["paid-options"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isShowSettings)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_InstanceDetailSettings)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
    (_ctx.modalQrCode.isShow)
      ? (_openBlock(), _createBlock(_component_ModalQrCode, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.modalEventLog.isShow)
      ? (_openBlock(), _createBlock(_component_ModalEventLog, { key: 4 }))
      : _createCommentVNode("", true)
  ], 64))
}